import { Tag } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import OptionContent from 'ui/fields/selects/PaginatedDealerSelect/component/Option';
import { humanize } from 'utils/global';

import Group from '../ModalDealerSelect/components/Group';

/**
 * @param {(user: object) => string} formatDisplayName
 */
const getColumns = formatDisplayName => [
  {
    sorter: true,
    title: <FormattedMessage id="username" defaultMessage="Username" />,
    dataIndex: 'displayName',
    render: (_, user) => (
      <React.Fragment>
        {formatDisplayName(user)}
        <div className="text-xs">{user.email}</div>
      </React.Fragment>
    ),
  },
  {
    width: '40%',
    title: (
      <FormattedMessage id="audito.model.builder.sections.section.question.parameters.role" defaultMessage="Roles" />
    ),
    dataIndex: 'roles',
    render: (roles = []) => (
      <div className="d-flex gap-2 flex-wrap">
        {roles.map(role => (
          <Tag className={classNames(role.toLowerCase(), 'm-0')}>
            <FormattedMessage id={`role.${role}`} defaultMessage={humanize(role)} />
          </Tag>
        ))}
      </div>
    ),
  },
  {
    title: <FormattedMessage id="group" defaultMessage="Group" />,
    dataIndex: 'groupId',
    render: groupId => groupId && <Group id={groupId} />,
  },
  {
    align: 'right',
    title: <FormattedMessage id="dealer" defaultMessage="Dealer" />,
    dataIndex: 'dealerIds',
    render: (dealerIds = []) =>
      dealerIds.map(dealerId => (
        <div key={dealerId}>
          <OptionContent dealerId={dealerId} />
        </div>
      )),
  },
];

export default getColumns;
